module.exports = __webpack_public_path__ + "static/media/B4.c27cf21a.png";